import { CorporateHomePageEntity } from '@/modules/homepage/domain/entities/CorporateHomePageEntity';
import { corporateHomepagesByIdRoute } from '@/modules/homepage/domain/routes/homepageRoutes';
import { CorporateHomepage } from '@/types/homepage';
import { getData } from '@/utils/corpo/request/getData';

import { getHomepages } from './getHomepages';

export const getHomepage = async (homepageId?: string) => {
  const hompages = (await getHomepages()) || [];
  const UUID = homepageId || (hompages.find((isDefault) => !!isDefault) || hompages?.[0])?.UUID;
  const response = await getData<CorporateHomepage>(corporateHomepagesByIdRoute(UUID));

  return response && new CorporateHomePageEntity(response).toHomepage();
};
